import { Component, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { DatatableClickEvent, DatatableComponent } from '@basis/angular-components';
import { URLSearchParams } from '@angular/http';
import { environment } from '../../environments/environment';
import { Situacoes } from '../entity/enumeraveis';
import { BaseComponent } from './base.component';
import { HomologacaoCurso } from '../entity/homologacao-curso.model';
import { HomologacaoCapacitadora } from 'app/entity/homologacao-capacitadora.model';
import { HomologacaoEvento } from '../entity/homologacao-evento.model';
import { HomologacaoDocencia } from '../entity/homologacao-docencia.model';
import * as FileSaver from 'file-saver';
import { HomologacaoBanca } from '../entity/homologacao-banca.model';
import { HomologacaoCursoExterior } from '../entity/homologacao-curso-exterior.model';
import { HomologacaoComissao } from '../entity/homologacao-comissao.model';
import { HomologacaoProducaoIntelectual } from '../entity/homologacao-producao-intelectual.model';
import { HomologacaoPosGraduacao } from '../entity/homologacao-pos-graduacao.model';
import { Homologacao } from 'app/entity/homologacao';

@Component({ template: '' })
export class BaseListComponent extends BaseComponent implements OnInit {
    filtro: FormGroup;
    @ViewChild('listagem') listagem: DatatableComponent;
    homologacao_capacitadora: HomologacaoCapacitadora = new HomologacaoCapacitadora;
    homologacao_atividade: any;
    displayAlterarMembroComissao = false;
    homologacao: Homologacao = new Homologacao;
    alterar_membro = this.formBuilder.group({
        id_usuario_receptor: [null, [Validators.required]],
        id: [null]
    });
    improcedente = this.formBuilder.group({
        descricao: [null, [Validators.required]],
        id: [null]
    });
    listaMembrosComissao: any[] = [];

    baseUrl = `${environment.apiEndpoint}`;
    displayImprocedente = false;
    codigoImprocedente: string;
    tituloImprocedente: string;
    atividadeImprocedente: any;
    dataDia: Date = new Date();
    linhaSelecionada: any;
    eventRecurso: DatatableClickEvent;
    modalRecurso = false;
    hoje: Date = new Date();
    dataPrazo: Date;
    disableButton: boolean = true;
    ehAberto: boolean = true;
    emptyMessage: string = "Nenhum registro encontrado.";
    nullMessage: string = "Preencha um dos campos acima para consultar.";
    eventLGPD: DatatableClickEvent;
    modalTermoAceiteLGPD = false;

    url(route: string, appendController: boolean = true, filter: any = null): string {
        const query = sessionStorage.getItem('filtro');
        let parametros;
        const params: URLSearchParams = new URLSearchParams();

        filter = Object.assign({}, filter, { id_lotacao: localStorage.getItem('lotacao') ? localStorage.getItem('lotacao') : '' });
        if (filter != null) {
            Object.keys(filter).map(k => params.set(k, filter[k]));
        }

        if (query) {
            parametros = this.obterParametros(query);
            const id_lotacao = localStorage.getItem('lotacao')
            parametros = { ...parametros, id_lotacao };
            Object.keys(parametros).map(k => params.set(k, parametros[k]));
        }

        return appendController ? `${this.baseUrl}/${this.controllerName}/${route}?${params.toString()}` : `${this.baseUrl}/${route}?${params.toString()}`;
    }

    ngOnInit() {
        this.listagem.pDatatableComponent.onHeaderCheckboxToggle.subscribe(x => {
            this.linhaSelecionada = x.checked ? undefined : this.linhaSelecionada;
            this.listagem.disableView = x.checked;
            this.listagem.extraButtons.forEach((button) => {
                button.disabled = button.name !== 'julgamento_lote' ? x.checked : button.disabled;
            })
        });

        if (this.filtro) {
            this.linhaSelecionada = undefined;
            this.activatedRoute.data.subscribe(data => {
                if (data && Object.keys(data).length > 0) {
                    this.filtro.patchValue(data);
                }
            });
            this.activatedRoute.params.subscribe(param => {
                if (param && Object.keys(param).length > 0) {
                    this.filtro.patchValue(param);
                }
            });
        }

        if (this.listagem) {
            // this.listagem.extraParams = { emptyMessage: 'Nenhum registro encontrado.' };
            this.listagem.pDatatableComponent.headerCheckboxToggleAllPages = true;
        }

        this.init();

    }

    excluirRegistro(registroId) {
        this.confirmacao.confirm({
            header: 'Confirmação',
            message: 'Deseja realmente remover este registro?',
            accept: () => {
                this.observableUtilPanelDoc.setBlockedPanel(true);
                this.service.Deletar(this.controllerName, registroId).subscribe(
                    () => {
                        this.listagem.refresh(this.filtro);
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                        this.showMsgSucess('Registro excluído com sucesso.');
                    },
                    err => {
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                        this.showMsgError(`Houve um erro ao excluir o registro. ${err._body}`)
                    }
                );
            }
        });
    }

    tratarExclusaoTurma(turma: any) {

        const listaCondicoes = [
            { condicao: this.listagem.value.length === 1, msg: 'É necessário ao menos uma turma no curso' },
            { condicao: turma.concluido, msg: 'Não é possível excluir turma com situação concluída' },
            { condicao: turma.em_execucao, msg: 'Não é possível excluir uma turma em execução' },
            {
                condicao: !this.ehGestorEpc && turma.aguardando,
                msg: 'É necessário perfil de Gestor CFC ou Gestor CRC para excluir turmas nesta situação'
            },
            {
                condicao: !turma.aguardando && !turma.editar_remover,
                msg: 'Não é possível excluir a turma faltando menos de 5 dias para o seu início'
            },
        ];

        const alerta = listaCondicoes.find(x => x.condicao);
        return alerta ? this.showMsgWarn(alerta.msg) : this.excluirRegistro(turma.id);
    }


    cancelarMembroComissao() {
        this.displayAlterarMembroComissao = false;
    }

    alterarMembroComissao() {
        if (this.alterar_membro.valid) {
            this.observableUtilPanelDoc.setBlockedPanel(true);
            this.homologacao.id = this.alterar_membro.get('id').value;
            this.homologacao.id_usuario_receptor = this.alterar_membro.get('id_usuario_receptor').value;
            this.service.Atualizar('homologacao/alterar-membro-comissao', this.homologacao).subscribe(() => {
                this.displayAlterarMembroComissao = false;
                this.alterar_membro.reset();
                this.listagem.refresh();
                this.observableUtilPanelDoc.setBlockedPanel(false);
            }, () => {
                this.observableUtilPanelDoc.setBlockedPanel(false);
            }, () => this.observableUtilPanelDoc.setBlockedPanel(false));
        } else {
            this.touchAll(this.alterar_membro);
        }
    }

    improcedenteEnviar() {
        if (this.improcedente.valid) {
            this.observableUtilPanelDoc.setBlockedPanel(true);
            this.service.Adicionar(`${this.controllerName}/improcedente`, this.improcedente.value).subscribe(() => {
                this.displayImprocedente = false;
                this.improcedente.reset();
                this.codigoImprocedente = '';
                this.tituloImprocedente = '';
                this.listagem.refresh();
                this.observableUtilPanelDoc.setBlockedPanel(false);
                this.showMsgSucess('Registro rejeitado como improcedente com sucesso')
            },
                () => {
                    this.observableUtilPanelDoc.setBlockedPanel(false);
                    this.showMsgError('Ocorreu um erro inesperado!}')

                })
        } else {
            this.touchAll(this.improcedente);
        }
    }

    cancelarImprocedente() {
        this.displayImprocedente = false;
        this.improcedente.reset();
        this.codigoImprocedente = '';
        this.tituloImprocedente = '';
    }

    carregarEstadoPaginacao() {
        const pagina = sessionStorage.getItem('pagina');

        if (pagina != null) {
            this.listagem.pDatatableComponent.first = Number(pagina);
        }
    }

    carregarEstadoFiltro() {
        let query, parametros;
        if (sessionStorage.getItem('turma_edicao') != null) {
            sessionStorage.removeItem('turma_edicao');
            sessionStorage.removeItem('filtro_turma_edicao');
        }

        query = sessionStorage.getItem('filtro');
        if (sessionStorage.getItem('funcionalidade') == this.router.url.split('/')[2] && query != null) {
            parametros = query.split('&')
                .map(str => {
                    const [key, value] = str.split('=');
                    return { [key]: decodeURI(value) };
                })
                .reduce((prev, curr) => Object.assign(prev, curr));
            Object.keys(parametros).forEach(key => {
                parametros[key] = parametros[key].split('%2C').length > 1 ? parametros[key].split('%2C') : parametros[key];
                if (!Array.isArray(parametros[key])) {
                    parametros[key] = parametros[key].split('+').length > 1 ? this.concatStringFiltro(parametros[key].split('+')) : parametros[key];
                    parametros[key] = parametros[key].replace('%2F', '/');
                }
                parametros[key] = parametros[key] == 'null' ? null : parametros[key];

                if (key == "exercicios" || key == "situacoes") {
                    let params = parametros[key];
                    parametros[key] = [] as number[];

                    if (Array.isArray(params)) {
                        params.forEach(element => {
                            parametros[key].push(element);
                        });
                    }
                    else {
                        parametros[key].push(params);
                    }
                }
            });

            setTimeout(() => this.filtro.patchValue(parametros), 2000);
        }
    }

    carregarEstado() {
        if (sessionStorage.getItem('funcionalidade') == this.router.url.split('/')[2]) {
            this.carregarEstadoPaginacao();
            this.carregarEstadoFiltro();

        } else {
            sessionStorage.removeItem('funcionalidade');
            sessionStorage.removeItem('filtro');
            sessionStorage.removeItem('pagina');
        }
    }

    tratarTurmaPrestarConta(obj, turma_status_aguardando) {
        this.observableUtilPanelDoc.setBlockedPanel(true);
        let permitePrazo: any;
        const dataFimString = obj.data_inicio_fim.split('-')[1];
        const dataFim = this.gerarData(dataFimString);

        this.service.obterPrazoPrestacao(dataFim.getFullYear()).subscribe((prazo: string) => {
            this.dataPrazo = new Date(prazo);
        })

        this.service.Obter("turma/verificarPrazoPorId/", obj['id']).subscribe(
            item => {
                this.observableUtilPanelDoc.setBlockedPanel(false);

                permitePrazo = item;

                if (item.prazoCapacitadoraAcabou) {
                    this.showMsgWarn(`O Prazo para prestação de contas de turmas de ${item.exercicio} está finalizado`);
                }
                else {
                    if (Number(obj.id_situacao) !== 12) { return this.showMsgWarn('Para prestar conta, o Curso deve estar deferido.'); }
                    if (!turma_status_aguardando) { return this.showMsgWarn('Não é possível Prestar Conta.'); }
                    const dataFimString = obj.data_inicio_fim.split('-')[1];
                    const dataFim = this.gerarData(dataFimString);
                    const anoTurma = dataFim.getFullYear();

                    if (this.ehCapacitadora && new Date(this.hoje.setHours(0, 0, 0, 0)) > this.dataPrazo) {
                        return this.showMsgWarn(`A data limite para prestar contas das turmas de ${anoTurma} é ${this.dataPrazo.toLocaleDateString()}`);
                    }
                    else if (this.ehCapacitadora && (anoTurma != 2019 && anoTurma != 2020) && permitePrazo.prazoCapacitadoraAcabou) {
                        return this.showMsgWarn(`A data limite para prestar contas das turmas de ${anoTurma} é ${this.dataPrazo.toLocaleDateString()}`);
                    }

                    this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                    this.router.navigate(['/atividades/turma/prestar-conta', obj['id']], { relativeTo: this.activatedRoute });

                }
            }, err => {
                super.showMsg('error', 'Mensagem de Erro', `Houve um erro ao verificar o prazo do registro.<br> ${err._body}`)
                this.observableUtilPanelDoc.setBlockedPanel(false);
            });

    }

    tratarEdicaoPrestarConta(obj, edicaoStatusAguardando) {
        let permitePrazo: any;
        let exercicio = Number(obj.data_fim.substring(0, 4));

        this.service.obterPrazoPrestacao(exercicio).subscribe(
            (prazo: string) => {
                this.dataPrazo = new Date(prazo);
            }
        );

        this.observableUtilPanelDoc.setBlockedPanel(true);
        this.service.Obter("edicaoEvento/verificarPrazoPorId/", obj['id']).subscribe(
            item => {
                this.observableUtilPanelDoc.setBlockedPanel(false);
                permitePrazo = item;
                if (item.prazoCapacitadoraAcabou) {
                    this.showMsgWarn(`o prazo para envio das atividades do exercício de ${item.exercicio} está finalizado.`);
                }
                else {
                    if (Number(obj.evento.id_situacao) !== 12) { return this.showMsgWarn('Para prestar conta, o Evento deve estar deferido.'); }
                    if (!edicaoStatusAguardando) { return this.showMsgWarn('Não é possível Prestar Conta.'); }
                    const dataFimString = obj.data_inicio_fim.split('-')[1];
                    const dataFim = this.gerarData(dataFimString);
                    const anoEdicao = dataFim.getFullYear();

                    if (this.ehCapacitadora && new Date(this.hoje.setHours(0, 0, 0, 0)) > this.dataPrazo) {
                        return this.showMsgWarn(`A data limite para prestar contas das edições de ${anoEdicao} é ${this.dataPrazo.toLocaleDateString()}`);
                    }
                    else if (this.ehCapacitadora && (anoEdicao != 2019 && anoEdicao != 2020) && permitePrazo.prazoCapacitadoraAcabou) {
                        return this.showMsgWarn(`A data limite para prestar contas das edições de ${anoEdicao} é ${this.dataPrazo.toLocaleDateString()}`);
                    }

                    this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);

                    this.service.Obter("edicaoEvento/VerificaTermoAceiteLGPD", obj.id).subscribe(data => {
                        if (!data) {
                            this.modalTermoAceiteLGPD = true;
                            this.eventLGPD = new DatatableClickEvent("edicao_prestar_conta", obj);
                            return;
                        }
                        else {
                            return Number(obj.id_tipo_certificacao) === 2 ?
                                this.router.navigate(['/atividades/edicao-evento/prestar-conta', obj['id']], { relativeTo: this.activatedRoute })
                                : this.router.navigate(['/atividades/edicao-evento/prestar-conta-individual', obj['id']], { relativeTo: this.activatedRoute });
                        }
                    });
                }
            }, err => {
                super.showMsg('error', 'Mensagem de Erro', `Houve um erro ao verificar o prazo do registro.<br> ${err._body}`)
                this.observableUtilPanelDoc.setBlockedPanel(false);
            });
    }

    lotacao(codigo: string, situacao: number) {
        const estado = codigo.split('-')[0];
        return situacao == 10 || situacao == 11 || estado == 'CF' ? 'CFC' : 'CRC-' + estado;
    }

    onRowSelected(event: any) {
        if (event.length === 0) {
            this.linhaSelecionada = undefined;
            this.listagem.disableView = false;
        } else if (event.length === 1) {
            this.linhaSelecionada = event[0];
            this.listagem.disableView = false;
        } else if (event.length > 1) {
            this.linhaSelecionada = undefined;
            this.listagem.disableView = true;
        }
    }

    onButtonClick(event: DatatableClickEvent) {

        if (!event.selection || event.selection.length === 0) {
            this.showMsgWarn('Antes de executar esta ação selecione um registro na tabela.');
            return;
        }

        if (event.selection.length > 1 && event.button !== 'julgamento_lote') {
            this.showMsgWarn('Não é possível executar esta ação com mais de um registro selecionado.');
            return;
        }

        let obj;
        let situacao;
        let listSituacao = [];
        let codigo;
        let nome;
        let atividade;
        let turma_status_aguardando;
        let edicao_status_aguardando;
        let flg_termoLGPD;

        obj = event.selection;

        if (event.selection && event.button !== 'julgamento_lote') {

            if (event.selection.length === 1) {
                obj = event.selection[0];
            } else {
                obj = event.selection;
            }

            Object.keys(obj).forEach(x => {
                if (x === 'norma') {
                    situacao = obj.norma.situacao == null ? null : obj.norma.situacao.id;
                } else if (x === 'situacao') {
                    situacao = obj.situacao == null ? null : obj.situacao.id;
                } else if (x == 'curso') {
                    situacao = obj.curso.situacao == null ? null : obj.curso.situacao.id;
                    codigo = obj.curso.codigo == null ? null : obj.curso.codigo;
                    nome = obj.curso.titulo_original == null ? null : obj.curso.titulo_original;
                    atividade = 'Curso';
                } else if (x == 'evento') {
                    situacao = obj.evento.situacao == null ? null : obj.evento.situacao.id;
                    codigo = obj.evento.codigo == null ? null : obj.evento.codigo;
                    nome = obj.evento.titulo == null ? null : obj.evento.titulo;
                    atividade = 'Evento';
                } else if (x == 'docencia') {
                    situacao = obj.docencia.situacao == null ? null : obj.docencia.situacao.id;
                    codigo = obj.docencia.codigo == null ? null : obj.docencia.codigo;
                    nome = obj.docencia.titulo == null ? null : obj.docencia.titulo;
                    atividade = 'Docência';
                } else if (x == 'capacitadora' && obj.capacitadora != null) {
                    situacao = obj.capacitadora == null ? null : obj.capacitadora.id_situacao;
                    codigo = obj.capacitadora.codigo == null ? null : obj.capacitadora.codigo;
                    nome = obj.capacitadora.nome == null ? null : obj.capacitadora.nome;
                    atividade = 'Capacitadora';
                } else if (x == 'banca') {
                    situacao = obj.banca.situacao.id == null ? null : obj.banca.situacao.id;
                    codigo = obj.banca.codigo == null ? null : obj.banca.codigo;
                    nome = obj.banca.titulo == null ? null : obj.banca.titulo;
                    atividade = 'Banca';
                } else if (x == 'producao_intelectual') {
                    situacao = obj.producao_intelectual.situacao.id == null ? null : obj.producao_intelectual.situacao.id;
                    codigo = obj.producao_intelectual.codigo == null ? null : obj.producao_intelectual.codigo;
                    nome = obj.producao_intelectual.titulo == null ? null : obj.producao_intelectual.titulo;
                    atividade = 'Produção Intelectual';
                } else if (x == 'pos_graduacao') {
                    situacao = obj.pos_graduacao.situacao.id == null ? null : obj.pos_graduacao.situacao.id;
                    codigo = obj.pos_graduacao.codigo == null ? null : obj.pos_graduacao.codigo;
                    nome = obj.pos_graduacao.titulo == null ? null : obj.pos_graduacao.titulo;
                    atividade = 'Pós Graduação';
                } else if (x == 'curso_exterior') {
                    situacao = obj.curso_exterior.situacao.id == null ? null : obj.curso_exterior.situacao.id;
                    codigo = obj.curso_exterior.codigo == null ? null : obj.curso_exterior.codigo;
                    nome = obj.curso_exterior.titulo == null ? null : obj.curso_exterior.titulo;
                    atividade = 'Curso Exterior';
                } else if (x == 'comissao') {
                    situacao = obj.comissao.situacao.id == null ? null : obj.comissao.situacao.id;
                    codigo = obj.comissao.codigo == null ? null : obj.comissao.codigo;
                    nome = obj.comissao.titulo == null ? null : obj.comissao.titulo;
                    atividade = 'Comissão';
                } else if (x == 'id_situacao') {
                    situacao = obj.id_situacao == null ? null : obj.id_situacao;
                }
            });
            Object.keys(obj).forEach(x => {
                if (x === 'aguardando') {
                    turma_status_aguardando = obj.aguardando == true ? true : false;
                }
                if (x === 'aguardando_evento') {
                    edicao_status_aguardando = obj.aguardando_evento == true ? true : false;
                }
            });
        } else if (Array.isArray(event.selection)) {

            obj = event.selection;
            const tiposDeAtividades = ['curso', 'evento', 'docencia', 'capacitadora', 'banca',
                'producao_intelectual', 'pos_graduacao', 'curso_exterior', 'comissao'];

            obj.forEach(objetoPercorrido => {

                const propriedadesFiltradas = Object.keys(objetoPercorrido)
                    .filter(prop => tiposDeAtividades.some(tipoAtividade => tipoAtividade === prop));

                propriedadesFiltradas.forEach((tipoAtividade: string) => {
                    if (tipoAtividade == 'curso') {
                        listSituacao.push(objetoPercorrido.curso.id_situacao);
                        return;
                    } else if (tipoAtividade == 'evento') {
                        listSituacao.push(objetoPercorrido.evento.id_situacao);
                        return;
                    } else if (tipoAtividade == 'docencia') {
                        listSituacao.push(objetoPercorrido.docencia.id_situacao);
                        return;
                    } else if (tipoAtividade == 'capacitadora') {
                        listSituacao.push(objetoPercorrido.capacitadora.id_situacao);
                        return;
                    } else if (tipoAtividade == 'banca') {
                        listSituacao.push(objetoPercorrido.banca.situacao.id);
                        return;
                    } else if (tipoAtividade == 'producao_intelectual') {
                        listSituacao.push(objetoPercorrido.producao_intelectual.situacao.id);
                        return;
                    } else if (tipoAtividade == 'pos_graduacao') {
                        listSituacao.push(objetoPercorrido.pos_graduacao.situacao.id);
                        return;
                    } else if (tipoAtividade == 'curso_exterior') {
                        listSituacao.push(objetoPercorrido.curso_exterior.situacao.id);
                        return;
                    } else if (tipoAtividade == 'comissao') {
                        listSituacao.push(objetoPercorrido.comissao.situacao.id);
                        return;
                    }
                });

            });

            listSituacao = listSituacao.filter((x, i) => listSituacao.indexOf(x) === i);
        }

        switch (event.button) {
            case 'julgar':{
                let isComissao = this.perfisLotado.filter(y => y.nome.toLowerCase() == 'comissão cfc').length > 0
                let isGestor = this.perfisLotado.filter(y => y.nome.toLowerCase() == 'gestor cfc').length > 0

                if (isComissao && !isGestor
                    && situacao != Situacoes['Em análise no CFC - Comissão']
                    && situacao != Situacoes['Em análise no CRC - Comissão']
                    && situacao != Situacoes['Aguardando análise no CFC - Comissão']
                    && situacao != Situacoes['Aguardando análise no CRC - Comissão']) {
                    this.showMsgWarn('Não é possível julgar, pois esse registro não está para a comissão')
                }
                else if (situacao == null) {
                    this.showMsgWarn('Situação não mapeada para ação de homologação! Favor entrar em contato com o CFC!');
                }
                else if (situacao == 12) {
                    this.showMsgWarn('Não é possível julgar, pois o registro selecionado se encontra Deferido.');
                } else if (situacao == 3) {
                    this.showMsgWarn('Antes do julgamento, é necessario receber a documentação.');
                } else if (situacao == 13 || situacao == 14 || situacao == 16) {
                    this.showMsgWarn('Não é possivel julgar, o mesmo está com o responsável.');
                } else if (situacao == Situacoes['Aguardando Câmara/Plenária - CFC - Deferido'] ||
                    situacao == Situacoes['Aguardando Câmara/Plenária - CFC - Indeferido'] ||
                    situacao == Situacoes['Aguardando Câmara/Plenária - CRC - Deferido'] ||
                    situacao == Situacoes['Aguardando Câmara/Plenária - CRC - Indeferido']) {
                    this.showMsgWarn(`Não é possível realizar julgamento em registros com a situação: ${Situacoes[situacao]}`);
                } else if (situacao == 8 || situacao == 9) {
                    this.observableUser.getValue.subscribe(
                        usuario => {
                            const permissaoGestor = this.perfisLotado.filter(y => y.nome.toLowerCase() == 'gestor cfc');
                            if (permissaoGestor.length > 0 || usuario.obj.id == obj['id_usuario_receptor']) {
                                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                                this.router.navigate(['./homologar', obj['id']], { relativeTo: this.activatedRoute });
                            } else {
                                this.showMsgWarn('Não é possivel julgar, pois o mesmo não está para seu perfil, o registro está apenas para visualização.');
                            }
                        },
                        error => (error.status == 403) ? window.location.href =
                            `${environment.apiEndpoint}/api/Autenticar/login` : null
                    );
                } else if (situacao == 4 || situacao == 5) {
                    this.observableUser.getValue.subscribe(
                        usuario => {
                            const permissaoGestor = this.perfisLotado.filter(y => y.nome.toLowerCase() == 'gestor crc');
                            if (permissaoGestor.length > 0 || usuario.obj.id == obj['id_usuario_receptor']) {

                                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                                this.router.navigate(['./homologar', obj['id']], { relativeTo: this.activatedRoute });
                            } else {
                                this.showMsgWarn('Não é possivel julgar, pois o mesmo não está para seu perfil, o registro está apenas para visualização.');
                            }
                        },
                        error => (error.status == 403) ? window.location.href =
                            `${environment.apiEndpoint}/api/Autenticar/login` : null
                    );
                } else {
                    this.observableUser.getValue.subscribe(
                        usuario => {
                            const permissaoGestor = this.perfisLotado.filter(y => y.nome.toLowerCase() == obj['nome_perfil_receptor']).length > 0;
                            if (permissaoGestor || usuario.obj.id == obj['id_usuario_receptor']) {
                                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                                this.router.navigate(['./homologar', obj['id']], { relativeTo: this.activatedRoute });
                            } else {
                                this.showMsgWarn('Não é possivel julgar, pois o mesmo não está para seu perfil, o registro está apenas para visualização.');
                            }
                        },
                        error => (error.status == 403) ? window.location.href =
                            `${environment.apiEndpoint}/api/Autenticar/login` : null
                    );
                }
                break;}
            case 'julgamento_lote':

                this.observableUtilPanelDoc.setBlockedPanel(true)

                const registrosComRascunho = obj.every(x =>
                    x.possui_rascunho_de_julgamento_federal ||
                    x.possui_rascunho_de_julgamento_regional);

                const registrosComSituacaoValida = listSituacao.every(x =>
                    x === Situacoes['Aguardando análise no CRC - Comissão'] ||
                    x === Situacoes['Em análise no CRC - Comissão'] ||
                    x === Situacoes['Aguardando análise no CFC - Comissão'] ||
                    x === Situacoes['Em análise no CFC - Comissão']);

                if (!(registrosComSituacaoValida && registrosComRascunho)) {
                    this.observableUtilPanelDoc.setBlockedPanel(false);
                    this.showMsgError('Não é possível concluir um Julgamento em Lote com registros que não possuem rascunho salvo ou em situações indevidas.');
                    break;
                }

                const idsHomologacoes = obj.map(x => x.id);

                this.service.ObterTodosPorListaDeIds(this.controllerName, idsHomologacoes).subscribe(
                    list => {
                        this.confirmacao.confirm({
                            header: 'Confirmação',
                            message: idsHomologacoes.length > 1 ?
                                'Deseja realmente realizar um Julgamento em Lote com o registro selecionado?' :
                                'Deseja realmente realizar um Julgamento em Lote com os registros selecionados?',
                            accept: () => {
                                this.service.v2JulgamentoEmLote(this.controllerName, list).subscribe(
                                    () => {
                                        this.observableUtilPanelDoc.setBlockedPanel(false);
                                        this.listagem.pDatatableComponent.selectionChange.emit();
                                        this.listagem.refresh(this.filtro);
                                        this.showMsgSucess('Julgamento em Lote realizado com sucesso');
                                    },
                                    err => {
                                        this.observableUtilPanelDoc.setBlockedPanel(false);
                                        this.listagem.pDatatableComponent.selectionChange.emit();
                                        this.showMsgError('Houve algum erro no prosseguimento do julgamento em Lote dos registros.')
                                    }
                                );
                            },
                            reject: () => {
                                this.observableUtilPanelDoc.setBlockedPanel(false);
                            }
                        })
                    },
                    err => {
                        this.listagem.pDatatableComponent.selectionChange.emit();
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                        this.showMsgError('Houve algum erro na busca dos Rascunhos de Julgamento.')
                    }
                );

                break;

            case 'edit':
                if (situacao == 18) {
                    this.showMsgWarn('Não é possível editar, pois o registro selecionado se encontra com status de autorizado.');
                    return;
                } else if (situacao == 3) {
                    this.showMsgWarn('Não é possível editar, pois o registro selecionado foi enviado e está aguardando entrega de documentação física.');
                    return;
                } else if (situacao == 4) {
                    this.showMsgWarn('Não é possível editar, pois o registro selecionado já está aguardando análise no CRC - Gestor');
                    return;
                } else if (situacao == 5) {
                    this.showMsgWarn('Não é possível editar, pois o registro selecionado já está em análise no CRC - Gestor.');
                    return;
                } else if (situacao == 6) {
                    this.showMsgWarn('Não é possível editar, pois o registro selecionado já está aguardando julgamento no CRC - Comissão.');
                    return;
                } else if (situacao == 7) {
                    this.showMsgWarn('Não é possível editar, pois o registro selecionado já está em julgamento no CRC - Comissão.');
                    return;
                } else if (situacao == 8) {
                    this.showMsgWarn('Não é possível editar, pois o registro selecionado já está aguardando análise no CFC - Gestor.');
                    return;
                } else if (situacao == 9) {
                    this.showMsgWarn('Não é possível editar, pois o registro selecionado já está em análise no CFC - Gestor.');
                    return;
                } else if (situacao == 10) {
                    this.showMsgWarn('Não é possível editar, pois o registro selecionado já está aguardando julgamento no CFC - Comissão.');
                    return;
                } else if (situacao == 11) {
                    this.showMsgWarn('Não é possível editar, pois o registro selecionado já está em julgamento no CFC - Comissão.');
                    return;
                } else if (situacao == 12) {
                    this.showMsgWarn('Não é possível editar, pois o registro selecionado já está deferido.');
                    return;
                } else if (situacao == 15) {
                    this.showMsgWarn('Não é possível editar, pois o registro selecionado já está com processo finalizado.');
                    return;
                } else if (situacao == 25) {
                    this.showMsgWarn('Não é possível editar, pois o registro selecionado foi rejeitado por improcedência.');
                    return;
                } else if (this.controllerName === 'prestacaoConta') {
                    this.tratarPrestacaoConta(obj, './editar');
                } else {
                    this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                    this.router.navigate(['./editar', obj['id']], { relativeTo: this.activatedRoute });
                }
                break;
            case 'autorizar':
                if (situacao == Situacoes.Autorizado) {
                    this.showMsgWarn('Não é possível autorizar novamente um registro que já foi autorizado.');
                    return;
                } else {
                    this.confirmacao.confirm({
                        header: 'Confirmação',
                        message: 'Deseja realmente autorizar este registro?',
                        accept: () => {
                            this.observableUtilPanelDoc.setBlockedPanel(true);
                            this.service.Atualizar(this.controllerName, { id: obj['id'], id_situacao: Situacoes.Autorizado }, { parcial: 'id_situacao' }).subscribe(
                                () => {
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    this.listagem.refresh(this.filtro);
                                    this.showMsgSucess('Registro autorizado com sucesso.');
                                },
                                err => {
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    this.showMsgError(`Houve um erro ao autorizar o registro. ${err}`)
                                }
                            );
                        }
                    })
                }
                break;
            case 'autorizar_norma':
                if (situacao == Situacoes.Autorizado) {
                    this.showMsgWarn('Não é possível autorizar novamente um registro que já foi autorizado.');
                    return;
                } else if (!obj['hasNatureza'] || !obj['hasPontuacao'] || !obj['hasRegraGAP']) {
                    this.showMsgWarn(`Para autorizar a norma é necessario que a mesma tenha Pontuação, Natureza e regra de Pontuação e grupo de Atividade.`);
                    return;
                } else {
                    this.confirmacao.confirm({
                        header: 'Confirmação',
                        message: 'Deseja realmente autorizar este registro?',
                        accept: () => {
                            this.observableUtilPanelDoc.setBlockedPanel(true);
                            this.service.Atualizar(this.controllerName, { id: obj['id'], id_situacao: Situacoes.Autorizado }, { parcial: 'id_situacao' }).subscribe(
                                () => {
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    this.listagem.refresh(this.filtro);
                                    this.showMsgSucess('Registro autorizado com sucesso.');
                                },
                                err => {
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    this.showMsgError(`Houve um erro ao autorizar o registro. ${err}`)
                                }
                            );
                        }
                    })
                }
                break;
            case 'profissionais_pendentes':
                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                this.router.navigate([`/parametrizacao/prazo-prestacao-conta/profissionais-pendentes`, obj['id']], { relativeTo: this.activatedRoute });
                break;
            case 'exibir_lancamento':
                this.observableUtilPanelDoc.setBlockedPanel(true);
                this.service.Obter(`${this.controllerName}/baixarRemessa`, obj['id']).subscribe(
                    () => {
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                        const dateInclusao = new Date(obj.data_inclusao);
                        const nomeArquivo = `remessa-${dateInclusao.getFullYear()}-${obj.id}.zip`;
                        // FileSaver.saveAs(this.b64toFile(data, null, "application/octet-stream"), nomeArquivo)
                        this.showMsgSucess(`O arquivo '${nomeArquivo}' foi baixado automaticamente, verifique na pasta de downloads.`);
                    }
                    , err => {
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                        this.showMsgError(`Houve um erro ao baixar o arquivo. ${err}`)
                    }
                );
                break;
            case 'ativar_inativar':
                if (situacao != Situacoes.Ativo && situacao != Situacoes.Inativo) {
                    this.showMsgWarn('Não é possível inativar/ativar este registro.');
                    return;
                } else {
                    this.confirmacao.confirm({
                        header: 'Confirmação',
                        message: `Deseja realmente ${situacao == 1 ? 'ativar' : 'inativar'} este registro?`,
                        accept: () => {
                            this.observableUtilPanelDoc.setBlockedPanel(true);
                            this.service.Atualizar(this.controllerName, { id: obj['id'], id_situacao: (situacao == 1 ? 2 : 1) }, { parcial: 'id_situacao' }).subscribe(
                                () => {
                                    this.listagem.refresh(this.filtro);
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    this.showMsgSucess(`Registro ${situacao == 1 ? 'ativado' : 'inativado'} com sucesso.`);
                                },
                                err => {
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    this.showMsgError(`Houve um erro ao ${situacao == 1 ? 'ativar' : 'inativar'} o registro. ${err}`)
                                });
                        }
                    })
                }
                break;
            case 'enviar_cadastro':
                if (situacao != Situacoes.Iniciado) {
                    this.showMsgWarn('Não é possível enviar este cadastro, o mesmo já foi enviado.');
                    return;
                } else if (obj['funcao_exercida_prestacao_conta'].length == 0) {
                    this.showMsgWarn('Não é possível enviar este cadastro, é necessário cadastrar ao menos uma função exercida');
                    return;
                } else {
                    this.service.Obter(this.controllerName + "/verificarPrazoPorExercicio/", obj['exercicio']).subscribe(
                        item => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                            if (item.prazoProfissionalAcabou && !this.ehGestorEpc) {
                                if (!item.profissionalPrazoExtra) {
                                    this.showMsgWarn(`O prazo para envio da prestação de contas do exercício ${item.exercicio} acabou.`);
                                    return;
                                }
                            }
                            this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                            this.tratarPrestacaoConta(obj, './enviar-cadastro');
                        }, err => {
                            super.showMsg('error', 'Mensagem de Erro', `Houve um erro ao verificar o prazo do registro.<br> ${err._body}`)
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        });
                }
                break;
            case 'alterar_responsavel':
                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                this.router.navigate(['./alterar-responsavel', obj['id']], { relativeTo: this.activatedRoute });
                break;
            case 'alterar_responsavel_homologacao':
                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                this.router.navigate(['/capacitadora/homologacao-capacitadora/alterar-responsavel-homologacao', obj.capacitadora.id], { relativeTo: this.activatedRoute });
                break;
            case 'abrir_lancamento':
                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                this.router.navigate(['./boleto', obj['id']], { relativeTo: this.activatedRoute });
                break;
            case 'view': ''
                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                if (obj.length != undefined) {
                    this.router.navigate(['./visualizar', obj[0]['id']], { relativeTo: this.activatedRoute });
                    break;
                }
                this.router.navigate(['./visualizar', obj['id']], { relativeTo: this.activatedRoute });
                break;
            case 'julgar_capacitadora':{
                let isComissao = this.perfisLotado.filter(y => y.nome.toLowerCase() == 'comissão cfc').length > 0
                let isGestor = this.perfisLotado.filter(y => y.nome.toLowerCase() == 'gestor cfc').length > 0

                if (isComissao && !isGestor
                    && situacao != Situacoes['Em análise no CFC - Comissão']
                    && situacao != Situacoes['Em análise no CRC - Comissão']
                    && situacao != Situacoes['Aguardando análise no CFC - Comissão']
                    && situacao != Situacoes['Aguardando análise no CRC - Comissão']) {
                    this.showMsgWarn('Não é possível julgar, pois esse registro não está para a comissão')
                }
                else if (situacao == null) {
                    this.showMsgWarn('Situação não mapeada para ação de homologação! Favor entrar em contato com o CFC!');
                }
                else if (situacao == 12) {
                    this.showMsgWarn('Não é possível julgar, pois o registro selecionado se encontra Deferido.');
                } else if (situacao == 3) {
                    this.showMsgWarn('Antes do julgamento, é necessario receber a documentação.');
                } else if (situacao == 13 || situacao == 14 || situacao == 16) {
                    this.showMsgWarn('Não é possivel julgar, o mesmo está com o responsável.');
                } else if (situacao == Situacoes['Aguardando Câmara/Plenária - CFC - Deferido'] ||
                    situacao == Situacoes['Aguardando Câmara/Plenária - CFC - Indeferido'] ||
                    situacao == Situacoes['Aguardando Câmara/Plenária - CRC - Deferido'] ||
                    situacao == Situacoes['Aguardando Câmara/Plenária - CRC - Indeferido']) {
                    this.showMsgWarn(`Não é possível realizar julgamento em registros com a situação: ${Situacoes[situacao]}`);
                } else if (situacao == 8 || situacao == 9) {
                    this.observableUser.getValue.subscribe(
                        usuario => {
                            const permissaoGestor = this.perfisLotado.filter(y => y.nome.toLowerCase() == 'gestor cfc');
                            if (permissaoGestor.length > 0 || usuario.obj.id == obj['id_usuario_receptor']) {
                                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                                this.router.navigate(['./homologar', obj['id']], { relativeTo: this.activatedRoute });
                            } else {
                                this.showMsgWarn('Não é possivel julgar, pois o mesmo não está para seu perfil, o registro está apenas para visualização.');
                            }
                        },
                        error => (error.status == 403) ? window.location.href =
                            `${environment.apiEndpoint}/api/Autenticar/login` : null
                    );
                } else if (situacao == 4 || situacao == 5) {
                    this.observableUser.getValue.subscribe(
                        usuario => {
                            const permissaoGestor = this.perfisLotado.filter(y => y.nome.toLowerCase() == 'gestor crc');
                            console.log(permissaoGestor)
                            if (permissaoGestor.length > 0 || usuario.obj.id == obj['id_usuario_receptor']) {
                                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                                this.router.navigate(['./homologar', obj['id']], { relativeTo: this.activatedRoute });
                            } else {
                                this.showMsgWarn('Não é possivel julgar, pois o mesmo não está para seu perfil, o registro está apenas para visualização.');
                            }
                        },
                        error => (error.status == 403) ? window.location.href =
                            `${environment.apiEndpoint}/api/Autenticar/login` : null
                    );
                } else {
                    this.observableUser.getValue.subscribe(
                        usuario => {
                            const permissaoGestor = this.perfisLotado.filter(y => y.nome.toLowerCase() == obj['nome_perfil_receptor']).length > 0;
                            if (permissaoGestor || usuario.obj.id == obj['id_usuario_receptor']) {
                                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                                this.router.navigate(['./homologar', obj['id']], { relativeTo: this.activatedRoute });
                            } else {
                                this.showMsgWarn('Não é possivel julgar, pois o mesmo não está para seu perfil, o registro está apenas para visualização.');
                            }
                        },
                        error => (error.status == 403) ? window.location.href =
                            `${environment.apiEndpoint}/api/Autenticar/login` : null
                    );
                }
                break;}
            case 'imprimir_cadastro_capacitadora':
                this.printById(obj['id'], 'Capacitadora_' + obj['codigo'], 'capacitadora', 'print');
                break;
            case 'imprimir_homologacao_capacitadora':
                this.printById(obj.capacitadora['id'], 'Capacitadora_' + obj.capacitadora['codigo'], 'capacitadora', 'print');
                break;
            case 'imprimir_cadastro_curso':
                this.printById(obj['id'], 'Curso_' + obj['codigo'], 'gerenciamentoCurso', 'print');
                break;
            case 'imprimir_cadastro_evento':
                this.printById(obj['id'], 'Evento_' + obj['codigo'], 'gerenciamentoEvento', 'print');
                break;
            case 'imprimir_homologacao_curso':
                this.printById(obj.curso.id, 'Curso_' + obj.curso.codigo, 'gerenciamentoCurso', 'print');
                break;
            case 'imprimir_homologacao_evento':
                this.printById(obj.evento.id, 'Evento_' + obj.evento.codigo, 'gerenciamentoEvento', 'print');
                break;
            case 'delete':
                if (obj.curso && this.gestorCfc) {
                    this.excluirRegistro(obj.id);
                } else if (situacao == 18) {
                    this.showMsgWarn('Não é possível excluir, pois o registro selecionado se encontra com status de autorizado.');
                    return;
                } else if (situacao == 3) {
                    this.showMsgWarn('Não é possível excluir, pois o registro selecionado foi enviado e aguardando entrega de documentação física.');
                    return;
                } else if (situacao == 4) {
                    this.showMsgWarn('Não é possível excluir, pois o registro selecionado já está aguardando análise no CRC - Gestor');
                    return;
                } else if (situacao == 5) {
                    this.showMsgWarn('Não é possível excluir, pois o registro selecionado já está em análise no CRC - Gestor.');
                    return;
                } else if (situacao == 6) {
                    this.showMsgWarn('Não é possível excluir, pois o registro selecionado já está aguardando julgamento no CRC - Comissão.');
                    return;
                } else if (situacao == 7) {
                    this.showMsgWarn('Não é possível excluir, pois o registro selecionado já está em julgamento no CRC - Comissão.');
                    return;
                } else if (situacao == 8) {
                    this.showMsgWarn('Não é possível excluir, pois o registro selecionado já está aguardando análise no CFC - Gestor.');
                    return;
                } else if (situacao == 9) {
                    this.showMsgWarn('Não é possível excluir, pois o registro selecionado já está em análise no CFC - Gestor.');
                    return;
                } else if (situacao == 10) {
                    this.showMsgWarn('Não é possível excluir, pois o registro selecionado já está aguardando julgamento no CFC - Comissão.');
                    return;
                } else if (situacao == 11) {
                    this.showMsgWarn('Não é possível excluir, pois o registro selecionado já está em julgamento no CFC - Comissão.');
                    return;
                } else if (situacao == 12 && this.controllerName !== 'turma') {
                    this.showMsgWarn('Não é possível excluir, pois o registro selecionado já está deferido.');
                    return;
                } else if (situacao == 15) {
                    this.showMsgWarn('Não é possível excluir, pois o registro selecionado já está com processo finalizado.');
                    return;
                } else if (situacao != Situacoes.Iniciado && this.perfisLotado.some(y => y.nome.toLowerCase() == 'Profissional')) {
                    this.showMsgWarn('Não é possível excluir, o profissional precisa ter a Situação Iniciada.');
                    return;
                } else if (obj.curso && (this.gestorCrc || this.ehCapacitadora)) {

                    if (obj.curso.id_situacao == Situacoes.Deferido) {
                        this.showMsgWarn('Não é possível excluir, pois o curso da turma selecionada se encontra com status de deferido.');
                        return;
                    } else {
                        this.tratarExclusaoTurma(obj);
                    }

                } else if (this.controllerName === 'turma') {
                    this.tratarExclusaoTurma(obj);
                } else if (this.dataDia > new Date(obj.prazo_capacitadora) && this.dataDia > new Date(obj.prazo_profissional)) {
                    this.showMsgWarn('Não é possível excluir o registro pois o Prazo encontra-se como Finalizado.');
                    return;
                }
                else {
                    this.excluirRegistro(obj.id);
                }
                break;
            case 'curso-turma':
                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                this.router.navigate(['/atividades/curso-prestacao-conta/listar-turma', obj['id']], { relativeTo: this.activatedRoute });
                break;
            case 'listar_turma_homologacao':
                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                this.router.navigate(['/atividades/curso-prestacao-conta/listar-turma-homologacao', obj.curso.id], { relativeTo: this.activatedRoute });
                break;
            case 'turma_prestar_conta':
                var dataCadastroCurso = new Date(obj.curso ? obj.curso.data_cadastro : obj.data_cadastro);
                var dataValidadeCurso = new Date(dataCadastroCurso.getFullYear() + 1, 12, 31);
                if ((this.gestorCrc || this.ehCapacitadora) && dataValidadeCurso < this.hoje) {
                    this.showMsgWarn('Não é possível Prestar Conta em cursos que estão com a validade expirada.');
                    return;
                } else {
                    //codigo de abrir a modal 
                    this.service.Obter("turma/VerificaTermoAceiteLGPD", obj.id).subscribe(data => {
                        if (!data) {
                            this.modalTermoAceiteLGPD = true;
                            this.eventLGPD = new DatatableClickEvent(event.button, event.selection);
                            return;
                        }
                        else {
                            //TODO: Colocar o codigo normal do processamento
                            this.tratarTurmaPrestarConta(obj, turma_status_aguardando);
                        }
                    });
                }
                break;
            case 'turma_prestar_conta_homologacao':
                var dataCadastroCurso = new Date(obj.curso ? obj.curso.data_cadastro : obj.data_cadastro);
                var dataValidadeCurso = new Date(dataCadastroCurso.getFullYear() + 1, 12, 31);
                if ((this.gestorCrc || this.ehCapacitadora) && dataValidadeCurso < this.hoje) {
                    this.showMsgWarn('Não é possível Prestar Conta em cursos que estão com a validade expirada.');
                    return;
                } else if (obj.id_situacao == 12) {
                    if (turma_status_aguardando) {
                        //colocar codigo da modal, se der certo abre a proxima tela.
                        this.service.Obter("turma/VerificaTermoAceiteLGPD", obj.id).subscribe(data => {
                            if (!data) {
                                this.modalTermoAceiteLGPD = true;
                                this.eventLGPD = new DatatableClickEvent(event.button, event.selection);
                                return;
                            }
                            else {
                                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                                this.router.navigate(['/atividades/turma/prestar-conta-homologacao', obj['id']], { relativeTo: this.activatedRoute });
                            }
                        });
                    } else {
                        this.showMsgWarn('Não é possível Prestar Conta.');
                        return;
                    }
                } else {
                    this.showMsgWarn('Para prestar conta, o Curso deve estar deferido.');
                }
                break;
            case 'turma_editar':
                if (obj.editar_remover) {
                    this.observableUtilPanelDoc.setBlockedPanel(true);
                    this.service.Obter("turma/verificarPrazoPorId/", obj['id']).subscribe(
                        item => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                            if (item.prazoCapacitadoraAcabou) {
                                this.showMsgWarn(`Não é possível editar atividades de exercícios que estão com os prazos para prestação de contas finalizados.`);
                            }
                            else {
                                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                                this.router.navigate(['/atividades/turma/editar', obj['id']], { relativeTo: this.activatedRoute });
                            }
                        }, err => {
                            super.showMsg('error', 'Mensagem de Erro', `Houve um erro ao verificar o prazo do registro.<br> ${err._body}`)
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        });

                } else {
                    const dtInicioString = obj.data_inicio_fim.substring(6, 10) + '-' + obj.data_inicio_fim.substring(3, 5) + '-' + obj.data_inicio_fim.substring(0, 2);
                    const dtInicio = new Date(dtInicioString + 'T00:00:00');
                    const dtFinalString = obj.data_inicio_fim.substring(19, 23) + '-' + obj.data_inicio_fim.substring(16, 18) + '-' + obj.data_inicio_fim.substring(13, 15);
                    const dtFim = new Date(dtFinalString + 'T00:00:00');

                    const dateDifInicio = Math.ceil(dtInicio.getTime()) - Math.ceil(this.dataDia.getTime());
                    //let dateDifFim = Math.ceil(dtFim.getTime()) - Math.ceil(this.dataDia.getTime());

                    const diffDaysInicio = Math.ceil(dateDifInicio / (1000 * 3600 * 24));
                    //let diffDaysFim = Math.ceil(dateDifFim / (1000 * 3600 * 24));

                    if (dtFim < this.dataDia) {
                        this.showMsgWarn('Esta turma já foi encerrada.');
                    } else if (diffDaysInicio > 0 && diffDaysInicio < 5) {
                        this.showMsgWarn('Não é possível editar turma, faltando menos de 5 dias para execução.');
                    } else if (obj.em_execucao) {
                        this.showMsgWarn('Não é possível editar um evento que já está Em Execução.');
                    } else {
                        this.observableUtilPanelDoc.setBlockedPanel(true);
                        this.service.Obter("turma/verificarPrazoPorId/", obj['id']).subscribe(
                            item => {
                                this.observableUtilPanelDoc.setBlockedPanel(false);
                                if (item.prazoCapacitadoraAcabou) {
                                    this.showMsgWarn(`Não é possível editar atividades de exercícios que estão com os prazos para prestação de contas finalizados.`);
                                }
                                else {
                                    return;
                                }
                            }, err => {
                                super.showMsg('error', 'Mensagem de Erro', `Houve um erro ao verificar o prazo do registro.<br> ${err._body}`)
                                this.observableUtilPanelDoc.setBlockedPanel(false);
                            });
                    }
                }
                break;
            case 'turma_editar_homologacao':
                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                this.router.navigate(['/atividades/turma/editar-homologacao', obj['id']], { relativeTo: this.activatedRoute });
                break;
            case 'turma_visualizar':
                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                this.router.navigate(['/atividades/turma/turma-visualizar', obj['id']], { relativeTo: this.activatedRoute });
                break;
            case 'turma_visualizar_homologacao':
                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                this.router.navigate(['/atividades/turma/turma-visualizar-homologacao', obj['id']], { relativeTo: this.activatedRoute });
                break;
            case 'enviar_cadastro_capacitadora':
                if (situacao == Situacoes['Processo Finalizado']) {
                    this.showMsgWarn('Não é possível enviar este cadastro, o mesmo está finalizado.');
                } else if ((situacao != Situacoes.Iniciado) && (situacao != Situacoes['Devolvido para Adequação'])
                    && (situacao != Situacoes['Aberto para Recurso'])) {
                    this.showMsgWarn('Não é possível enviar este cadastro, o mesmo já foi enviado.');
                } else {
                    let id_situacao: number;
                    this.homologacao_capacitadora.id_capacitadora = obj['id'];
                    if (situacao == Situacoes['Aberto para Recurso']) {
                        this.homologacao_capacitadora.nome_perfil_receptor = 'gestor cfc';
                        id_situacao = Situacoes['Aguardando análise no CFC - Gestor'];
                    } else if (situacao == Situacoes['Devolvido para Adequação']) {
                        const perfil = obj['nome_pendencia_receptor'];
                        this.homologacao_capacitadora.nome_perfil_receptor = perfil;
                        
                        const situacoesMap = {
                        'gestor cfc': Situacoes['Aguardando análise no CFC - Gestor'],
                        'gestor crc': Situacoes['Aguardando análise no CRC - Gestor'],
                        'comissao crc': Situacoes['Aguardando análise no CRC - Comissão'],
                        'comissao cfc': Situacoes['Aguardando análise no CFC - Comissão'],
                        };
                        
                        if (situacoesMap.hasOwnProperty(perfil)) {
                            id_situacao = situacoesMap[perfil];
                        } else {
                            id_situacao = Situacoes['Aguardando análise no CRC - Gestor'];
                        }
                    }

                    this.confirmacao.confirm({
                        header: 'Confirmação',
                        message: `Deseja realmente enviar este registro?`,
                        accept: () => {
                            this.observableUtilPanelDoc.setBlockedPanel(true);
                            this.service.Atualizar(this.controllerName + '/atualizaSituacao', { id: obj['id'], id_situacao }, { parcial: 'id_situacao' }).subscribe(
                                () => {
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    this.listagem.refresh(this.filtro);
                                    this.showMsgSucess(`Registro foi enviado com sucesso.`);
                                },
                                err => {
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    this.showMsgError(`Houve um erro ao enviar o registro. ${err}`)
                                }
                            );
                            this.service.Atualizar(this.controllerName + '/atualizaParcial', this.homologacao_capacitadora).subscribe(() => { });
                        }
                    })
                }
                break;
            case 'enviar_cadastro_justificativa':
                if (situacao === Situacoes['Processo Finalizado']) {
                    this.showMsgWarn('Não é possível enviar este cadastro, o mesmo está finalizado.');
                    return;
                }

                if (situacao !== Situacoes.Iniciado &&
                    situacao !== Situacoes['Devolvido para Adequação'] &&
                    situacao !== Situacoes['Aberto para Recurso']) {
                    this.showMsgWarn('Não é possível enviar este cadastro, o mesmo já foi enviado.');
                    return;
                }

                const questionamento = situacao === Situacoes['Aberto para Recurso'] ?
                    'A justificativa selecionada está aberta para recurso. Deseja realmente interpor recurso?' :
                    'Deseja realmente enviar este registro?';

                this.confirmacao.confirm({
                    header: 'Confirmação',
                    message: questionamento,
                    accept: () => {
                        if (situacao === Situacoes['Aberto para Recurso']) {
                            this.router.navigate(['./abrir-recurso', obj['id']], { relativeTo: this.activatedRoute });
                        }

                        if (situacao !== Situacoes['Aberto para Recurso']) {
                            this.observableUtilPanelDoc.setBlockedPanel(true);
                            this.service.EnviarParaJulgamento(this.controllerName, obj['id']).subscribe(
                                () => {
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    this.listagem.refresh(this.filtro);
                                    this.showMsgSucess(`Registro foi enviado com sucesso.`);
                                },
                                err => {
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    if (err.status === 412) {
                                        this.showMsgWarn(`Atenção.<br> ${err._body}`)
                                        this.listagem.refresh(this.filtro);
                                        return;
                                    }

                                    this.showMsgError(`Houve um erro ao enviar o registro. ${err}`)
                                });
                        }
                    },
                    reject: () => {
                        if (situacao === Situacoes['Aberto para Recurso']) {
                            this.naoAbrirRecurso(obj['id'], this.controllerName, true, 500);
                        }
                    }
                });

                break;
            case 'enviar_cadastro_homologacao':
                if (situacao == Situacoes['Processo Finalizado']) {
                    this.showMsgWarn('Não é possível enviar este cadastro, o mesmo está finalizado.');
                } else if ((situacao != Situacoes.Iniciado) && (situacao != Situacoes['Devolvido para Adequação'])
                    && (situacao != Situacoes['Aberto para Recurso'])) {
                    this.showMsgWarn('Não é possível enviar este cadastro, o mesmo já foi enviado.');
                    return;
                } else {
                    var today = new Date();
                    today.setDate(today.getDate() + 5);
                    if (situacao === Situacoes.Iniciado && this.controllerName == 'gerenciamentoCurso') {
                        this.service.Obter("turma/VerificaDataInicio", obj['id']).subscribe(dataTurma => {
                            var data_inicio = new Date(dataTurma);
                            if (today.toISOString().split('T')[0].replace(/-/g, '') <= data_inicio.toISOString().split('T')[0].replace(/-/g, '')) {
                                this.service.Obter("turma/VerificaTermoAceiteLGPDCurso", obj['id']).subscribe(data => {
                                    if (!data) {
                                        this.modalTermoAceiteLGPD = true;
                                        this.eventLGPD = new DatatableClickEvent(event.button, event.selection);
                                        return;
                                    }
                                    else
                                        this.enviarCadastroHomologacao(obj, situacao);
                                }, err => {
                                    super.showMsg('error', 'Mensagem de Erro', `Houve um erro ao verificar termo de aceite LGPD.<br> ${err._body}`)
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                });
                            }
                            else {
                                this.showMsgWarn(`Cadastro fora do prazo permitido. Favor verificar a data de início das turmas.`);
                                return;
                            }
                        }, err => {
                            super.showMsg('error', 'Mensagem de Erro', `Houve um erro ao verificar Data inicio da Turma.<br> ${err._body}`)
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        });
                    }
                    else if (situacao === Situacoes.Iniciado && this.controllerName == 'gerenciamentoEvento') {
                        this.service.Obter("edicaoEvento/VerificaDataInicio", obj['id']).subscribe(dataEdicao => {
                            var data_inicio = new Date(dataEdicao);
                            if (today.toISOString().split('T')[0].replace(/-/g, '') <= data_inicio.toISOString().split('T')[0].replace(/-/g, '')) {
                                this.service.Obter("edicaoEvento/VerificaTermoAceiteLGPDEvento", obj['id']).subscribe(data => {
                                    if (!data) {
                                        this.modalTermoAceiteLGPD = true;
                                        this.eventLGPD = new DatatableClickEvent(event.button, event.selection);
                                        return;
                                    }
                                    else
                                        this.enviarCadastroHomologacao(obj, situacao);
                                }, err => {
                                    super.showMsg('error', 'Mensagem de Erro', `Houve um erro ao verificar termo de aceite LGPD.<br> ${err._body}`)
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                });
                            }
                            else {
                                this.showMsgWarn(`Cadastro fora do prazo permitido. Favor verificar a data de início das edições.`);
                                return;
                            }
                        }, err => {
                            super.showMsg('error', 'Mensagem de Erro', `Houve um erro ao verificar Data inicio da Edição.<br> ${err._body}`)
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        });
                    }
                    else {
                        //se nao processo como era antes
                        this.enviarCadastroHomologacao(obj, situacao);
                    }
                }
                break;
            case 'turma_incluir':
                var dataCadastroCurso = new Date(obj.curso ? obj.curso.data_cadastro : obj.data_cadastro);
                var dataValidadeCurso = new Date(dataCadastroCurso.getUTCFullYear() + 1, 11, 31);

                var anoValidadeCurso = dataValidadeCurso.getUTCFullYear();
                var data2020 = new Date('2020');
                var ano2020 = data2020.getUTCFullYear();

                if (!this.gestorCfc) {
                    if ((this.gestorCrc || this.ehCapacitadora)
                        && dataValidadeCurso < this.hoje
                        && anoValidadeCurso != ano2020) {
                        this.showMsgWarn('Não é possível incluir turmas em Cursos com a Data de Validade expirada.');
                        return;
                    }
                }
                if (situacao == Situacoes.Deferido || situacao == Situacoes.Iniciado || situacao == Situacoes['Devolvido para Adequação'] || situacao == Situacoes['Aberto para Recurso']) {
                    this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                    this.router.navigate(['/atividades/turma/turma-incluir', obj['id']], { relativeTo: this.activatedRoute });
                } else {
                    this.showMsgWarn(`Só é possível incluir turma para curso com a Situação Deferido`);
                }
                break;
            case 'turma_incluir_homologacao':
                var dataCadastroCurso = new Date(obj.curso ? obj.curso.data_cadastro : obj.data_cadastro);
                var dataValidadeCurso = new Date(dataCadastroCurso.getFullYear() + 1, 11, 31);

                var anoValidadeCurso = dataValidadeCurso.getUTCFullYear();
                var data2020 = new Date('2020');
                var ano2020 = data2020.getUTCFullYear();

                if (!this.gestorCfc) {
                    if ((this.gestorCrc || this.ehCapacitadora)
                        && dataValidadeCurso < this.hoje
                        && anoValidadeCurso != ano2020) {
                        this.showMsgWarn('Não é possível incluir turma, pois o curso selecionado está com a validade expirada.');
                        return;
                    }
                }
                if (!(situacao == Situacoes.Indeferido || situacao == Situacoes["Aguardando Câmara/Plenária - CFC - Indeferido"] || situacao == Situacoes["Aguardando Câmara/Plenária - CRC - Indeferido"])) {
                    this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                    this.router.navigate(['/atividades/turma/turma-incluir-homologacao', obj.curso.id], { relativeTo: this.activatedRoute });
                } else {
                    this.showMsgWarn(`Só é possível incluir turma para curso com a Situação Deferido`);
                }
                break;
            case 'evento-edicao':
                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                this.router.navigate(['/atividades/evento-prestacao-conta/listar-edicao', obj['id']], { relativeTo: this.activatedRoute });
                break;
            case 'evento_edicao_homologacao':
                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                this.router.navigate(['/atividades/evento-prestacao-conta/listar-edicao-homologacao', obj.evento.id], { relativeTo: this.activatedRoute });
                break;
            case 'edicao_editar':
                if (obj.editar_remover) {
                    this.observableUtilPanelDoc.setBlockedPanel(true);
                    this.service.Obter("edicaoEvento/verificarPrazoPorId/", obj['id']).subscribe(
                        item => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                            if (item.prazoCapacitadoraAcabou) {
                                this.showMsgWarn(`Não é possível editar atividades de exercícios que estão com os prazos para prestação de contas finalizados.`);
                            }
                            else {
                                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                                this.router.navigate(['/atividades/edicao-evento/editar', obj['id']], { relativeTo: this.activatedRoute });
                            }
                        }, err => {
                            super.showMsg('error', 'Mensagem de Erro', `Houve um erro ao verificar o prazo do registro.<br> ${err._body}`)
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        });

                } else {
                    this.showMsgWarn('Não é possível editar turma, faltando menos de 5 dias para execução.');
                    return;
                }
                break;
            case 'edicao_editar_homologacao':
                if (obj.editar_remover || this.perfisLotado.some(x => x.nome == 'Gestor CFC')) {
                    this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                    this.router.navigate(['/atividades/edicao-evento/editar-homologacao', obj['id']], { relativeTo: this.activatedRoute });
                } else {
                    this.showMsgWarn('Apenas perfil "Gestor CFC" pode alterar turmas que não estão em execução ou faltando menos de 5 dias.');
                    return;
                }
                break;
            case 'edicao_visualizar':
                if (obj['id_tipo_certificacao'] == 2) {
                    this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                    this.router.navigate(['/atividades/edicao-evento/edicao-visualizar', obj['id']], { relativeTo: this.activatedRoute });
                } else {

                    this.showMsgWarn('Não é possível Visualizar a edição Individual.');
                }
                break;
            case 'edicao_visualizar_homologacao':
                if (obj['id_tipo_certificacao'] == 2) {
                    this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                    this.router.navigate(['/atividades/edicao-evento/edicao-visualizar-homologacao', obj['id']], { relativeTo: this.activatedRoute });
                } else {

                    this.showMsgWarn('Não é possível Visualizar a edição Individual.');
                }
                break;
            case 'edicao_prestar_conta':
                if(obj.data_exclusao !== null && obj.data_exclusao !== undefined){
                    this.showMsgWarn('Não é possível realizar a prestação de contas, pois a edição foi excluída pelo usuário.');
                    return;
                }
                this.tratarEdicaoPrestarConta(obj, edicao_status_aguardando);
                break;
            case 'edicao_prestar_conta_homologacao':
                if(obj.data_exclusao !== null && obj.data_exclusao !== undefined){
                    this.showMsgWarn('Não é possível realizar a prestação de contas, pois a edição foi excluída pelo usuário.');
                    return;
                }
                if (obj.evento.id_situacao == 12) {
                    if (edicao_status_aguardando) {
                        this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);

                        this.service.Obter("edicaoEvento/VerificaTermoAceiteLGPD", obj.id).subscribe(data => {
                            if (!data) {
                                this.modalTermoAceiteLGPD = true;
                                this.eventLGPD = new DatatableClickEvent("edicao_prestar_conta_homologacao", obj);
                                return;
                            }
                            else {
                                if (obj['id_tipo_certificacao'] == 2) {
                                    this.router.navigate(['/atividades/edicao-evento/prestar-conta-homologacao', obj['id']], { relativeTo: this.activatedRoute });
                                } else {
                                    this.router.navigate(['/atividades/edicao-evento/prestar-conta-individual-homologacao', obj['id']], { relativeTo: this.activatedRoute });
                                }
                            }
                        });

                    } else {
                        this.showMsgWarn('Não é possível Prestar Conta.');
                        return;
                    }
                } else {
                    this.showMsgWarn('Para prestar conta, o Evento deve estar deferido.');
                }
                break;
            case 'edicao_incluir':
                var dataCadastroEvento = new Date(obj.evento ? obj.evento.data_cadastro : obj.data_cadastro);
                var dataValidadeEvento = new Date(dataCadastroEvento.getFullYear() + 1, 11, 31);

                var anoValidadeEvento = dataValidadeEvento.getUTCFullYear();
                var data2020 = new Date('2020');
                var ano2020 = data2020.getUTCFullYear();

                if (situacao == Situacoes.Deferido ||
                    situacao == Situacoes.Iniciado ||
                    situacao == Situacoes['Devolvido para Adequação'] ||
                    situacao == Situacoes['Aberto para Recurso']
                    && dataValidadeEvento < this.hoje
                    && anoValidadeEvento != ano2020) {
                    this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                    this.router.navigate(['/atividades/edicao-evento/incluir-edicao', obj['id']], { relativeTo: this.activatedRoute });
                } else if (situacao == Situacoes.Indeferido) {
                    this.showMsgWarn('Não é possível cadastrar edições para evento que foram indeferidos.');
                } else {
                    this.showMsgWarn(`Não é possível incluir Edições para Eventos com a situação ${Situacoes[situacao]}`);
                }
                break;
            case 'edicao_incluir_homologacao':
                var dataCadastroEvento = new Date(obj.evento ? obj.evento.data_cadastro : obj.data_cadastro);
                var dataValidadeEvento = new Date(dataCadastroEvento.getFullYear() + 1, 11, 31);

                var anoValidadeEvento = dataValidadeEvento.getUTCFullYear();
                var data2020 = new Date('2020');
                var ano2020 = data2020.getUTCFullYear();

                if (situacao == Situacoes.Deferido ||
                    situacao == Situacoes.Iniciado ||
                    situacao == Situacoes['Devolvido para Adequação'] ||
                    situacao == Situacoes['Aberto para Recurso']
                    && dataValidadeEvento < this.hoje
                    && anoValidadeEvento != ano2020) {
                    this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                    this.router.navigate(['/atividades/edicao-evento/incluir-edicao-homologacao', obj.evento.id], { relativeTo: this.activatedRoute });
                } else if (situacao == Situacoes.Indeferido) {
                    this.showMsgWarn('Não é possível cadastrar edições para evento que foram indeferidos.');
                }
                else {
                    this.showMsgWarn(`Não é possível incluir Edições para Eventos com a situação ${Situacoes[situacao]}`);
                }
                break;
            case 'relatorio_atividade':
                this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
                this.router.navigate(['./simular', obj['id']], { relativeTo: this.activatedRoute });
                break;
            case 'certificado_prestacao_conta':
                if (situacao == Situacoes['Em Análise'] || obj['nome_situacao'] == 'Em Análise') {
                    this.service.ObterPermissaoGerarCertificado(`prestacaoConta/verificarSituacaoAtividadesProfissionais/${obj['id']}`).subscribe(
                        data => {
                            if (data == true) {
                                this.observableUtilPanelDoc.setBlockedPanel(true);
                                this.service.GerarCertidao('relatorio/gerarCertificado', { id: obj['id'], id_lotacao: localStorage.getItem('lotacao'), logo: localStorage.getItem('path') }).subscribe(x => {
                                    FileSaver.saveAs(new Blob([x.blob()], { type: x['_body'].type }), obj['cpf']);
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                },
                                    () => {
                                        this.showMsgError(`Houve uma pequena instabilidade na geração do seu certificado. Por favor, tente novamente em alguns instantes.`);
                                        this.observableUtilPanelDoc.setBlockedPanel(false);
                                    })
                            } else {
                                this.showMsgWarn('Para gerar o certificado é necessário que a situação esteja concluída ou todas as atividades da Prestação de Contas estarem Deferidas, Finalizadas ou Abertas para Recurso');
                                return;
                            }

                        })
                } else if (situacao == Situacoes.Concluído || obj['nome_situacao'] == 'Concluído') {
                    this.observableUtilPanelDoc.setBlockedPanel(true);
                    this.service.GerarCertidao('relatorio/gerarCertificado', { id: obj['id'], id_lotacao: localStorage.getItem('lotacao'), logo: localStorage.getItem('path') }).subscribe(x => {
                        FileSaver.saveAs(new Blob([x.blob()], { type: x['_body'].type }), obj['cpf']);
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                    },
                        () => {
                            this.showMsgError(`Houve uma pequena instabilidade na geração do seu certificado. Por favor, tente novamente em alguns instantes.`);
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        })
                } else {
                    this.showMsgWarn('Para gerar o certificado é necessário que a situação esteja concluída ou todas as atividades da Prestação de Contas estarem Deferidas, Finalizadas ou Abertas para Recurso');
                    return;
                }
                break;
            case 'alterar_membro_comissao':
                if (situacao == 10 || situacao == 11) {
                    if (this.perfisLotado.some(x => x.nome == 'Gestor CFC')) {
                        this.observableUtilPanelDoc.setBlockedPanel(true);
                        const lotacao = this.lotacao(codigo, situacao);
                        this.service.ListarTodosUsuarios('usuario', 'Comissão CFC', lotacao).subscribe(
                            data => {
                                this.listaMembrosComissao = data;
                                this.displayAlterarMembroComissao = true;
                                this.alterar_membro.get('id').setValue(obj['id']);
                                this.observableUtilPanelDoc.setBlockedPanel(false);
                            },
                            () => this.observableUtilPanelDoc.setBlockedPanel(false),
                            () => this.observableUtilPanelDoc.setBlockedPanel(false)
                        )
                    } else {
                        this.showMsgWarn('Somente perfis Gestores CFC podem alterar o membro da comissao');
                        return;
                    }
                } else if (situacao == 6 || situacao == 7) {
                    if (this.perfisLotado.some(x => x.nome == 'Gestor CRC')) {
                        this.observableUtilPanelDoc.setBlockedPanel(true);
                        const lotacao = this.lotacao(codigo, situacao);
                        this.service.ListarTodosUsuarios('usuario', 'Comissão CRC', lotacao).subscribe(
                            data => {
                                this.listaMembrosComissao = data;
                                this.displayAlterarMembroComissao = true;
                                this.alterar_membro.get('id').setValue(obj['id']);
                                this.observableUtilPanelDoc.setBlockedPanel(false);
                            },
                            () => this.observableUtilPanelDoc.setBlockedPanel(false),
                            () => this.observableUtilPanelDoc.setBlockedPanel(false)
                        )
                    } else {
                        this.showMsgWarn('Somente perfis Gestores CRC podem alterar o membro da comissao');
                        return;
                    }
                } else {
                    this.showMsgWarn('Não é possível alterar o membro da comissão');
                    return;
                }
                break;
            case 'improcedente':
                if (situacao == 9 || situacao == 8 || situacao == 5 || situacao == 4
                    || situacao == 6 || situacao == 7 || situacao == 10 || situacao == 11) {
                    this.displayImprocedente = true;
                    this.improcedente.get('id').setValue(obj['id']);
                    this.codigoImprocedente = codigo;
                    this.tituloImprocedente = nome;
                    this.atividadeImprocedente = atividade;
                } else {
                    this.showMsgWarn('Não é possível julgar como improcedente.');
                    return;
                }
                break;
            case 'abrir-recurso':
                if (obj['id_situacao'] === Situacoes['Aberto para Recurso']) {
                    this.eventRecurso = new DatatableClickEvent(event.button, event.selection);
                    this.modalRecurso = true;
                } else {
                    this.showMsgWarn('Não é permitido abrir recurso nesse momento.');
                }
                break;
            case 'abrir-recurso2':
                if (obj.situacao.id === Situacoes['Aberto para Recurso']) {
                    this.eventRecurso = new DatatableClickEvent(event.button, event.selection);
                    this.modalRecurso = true;
                } else {
                    this.showMsgWarn('Não é permitido abrir recurso nesse momento.');
                }
                break;
            case 'desfazer_transicao':
                if (situacao == Situacoes['Aguardando análise no CFC - Comissão'] ||
                    situacao == Situacoes['Aguardando análise no CFC - Gestor'] ||
                    situacao == Situacoes['Aguardando análise no CRC - Gestor'] ||
                    situacao == Situacoes['Aguardando análise no CRC - Comissão'] ||
                    situacao == Situacoes['Deferido'] ||
                    situacao == Situacoes['Indeferido'] ||
                    situacao == Situacoes['Aguardando Câmara/Plenária - CRC - Deferido'] ||
                    situacao == Situacoes['Aguardando Câmara/Plenária - CFC - Deferido'] ||
                    situacao == Situacoes['Aguardando Câmara/Plenária - CRC - Indeferido'] ||
                    situacao == Situacoes['Aguardando Câmara/Plenária - CFC - Indeferido'] ||
                    situacao == Situacoes['Rejeitado por Improcedência']
                ) {
                    this.confirmacao.confirm({
                        header: 'Confirmação',
                        message: `Deseja realmente desfazer o julgamento?`,
                        accept: () => {
                            this.observableUtilPanelDoc.setBlockedPanel(true);
                            this.service.DesfazerTransicaoHomologacao(this.controllerName, obj).subscribe(
                                () => {
                                    this.listagem.refresh(this.filtro);
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    this.showMsgSucess(`Julgamento desfeito com sucesso.`);
                                },
                                err => {
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    this.showMsgError(`Houve um erro ao desfazer julgamento. ${err._body}`)
                                });
                        }
                    });
                } else {
                    this.showMsgWarn(`Não há julgamento a ser desfeito.`);
                }
                break;
        }
    }

    tratarPrestacaoConta(obj, rota) {

        if (this.ehProfissional &&
            this.DataSemHora(new Date()) > this.DataSemHora(new Date(obj.anoExercicio + 1, 1, 7))) {
            return this.showMsgWarn(`A data limite para prestar contas do ano de ${obj.exercicio} é 31/01/${obj.exercicio + 1}`);
        }
        this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
        this.router.navigate([rota, obj['id']], { relativeTo: this.activatedRoute });
    }

    obterParametros(query) {
        let parametros;
        parametros = query.split('&')
            .map(str => {
                const [key, value] = str.split('=');
                return { [key]: decodeURI(value) };
            })
            .reduce((prev, curr) => Object.assign(prev, curr));
        Object.keys(parametros).forEach(key => {
            parametros[key] = parametros[key].split('%2C').length > 1 ? parametros[key].split('%2C') : parametros[key];
            if (!Array.isArray(parametros[key])) {
                parametros[key] = parametros[key].split('+').length > 1 ? this.concatStringFiltro(parametros[key].split('+')) : parametros[key];
                parametros[key] = parametros[key].replace('%2F', '/');
            }
            parametros[key] = parametros[key] == 'null' ? null : parametros[key];

            if (key == "exercicios" || key == "situacoes") {
                let param = parametros[key];
                parametros[key] = [] as number[];

                if (Array.isArray(param)) {
                    param.forEach(element => {
                        parametros[key].push(element);
                    });
                }
                else {
                    parametros[key].push(param);
                }
            }
        });

        return parametros;
    }
    mostrarMensagemDeErroExclusao(err: any) {
        this.showMsgError(`Houve um erro ao excluir o registro. ${err._body}`)
    }

    enviarCadastroHomologacao(obj: any, situacao: any) {
        let id_situacao: number;
        let propriedades: string[];
        let nome_perfil_receptor: string;
        if (situacao === Situacoes.Iniciado || situacao === Situacoes['Devolvido para Adequação']) {
            propriedades = ['id_situacao'];
        }
        if (situacao == Situacoes['Aberto para Recurso']) {
            nome_perfil_receptor = 'gestor crc';
            id_situacao = Situacoes['Aguardando análise no CRC - Gestor'];
        } else {
            obj['nome_pendencia_receptor'] ? nome_perfil_receptor = obj['nome_pendencia_receptor'] : nome_perfil_receptor = 'gestor crc';
            if (nome_perfil_receptor == 'gestor cfc') {
                id_situacao = Situacoes['Aguardando análise no CFC - Gestor']
            } else if (nome_perfil_receptor == 'gestor crc') {
                id_situacao = Situacoes['Aguardando análise no CRC - Gestor']
            } else if (nome_perfil_receptor == 'comissao crc') {
                id_situacao = Situacoes['Aguardando análise no CRC - Comissão']
            } else {
                id_situacao = Situacoes['Aguardando análise no CFC - Comissão']
            }
        }

        if (this.controllerName == 'gerenciamentoDocencia') {
            this.homologacao_atividade = new HomologacaoDocencia();
            this.homologacao_atividade.nome_perfil_receptor = nome_perfil_receptor;
            this.homologacao_atividade.id_docencia = obj['id'];
            this.homologacao_atividade.docencia = { id: obj['id'], id_situacao };
            propriedades.push('data_envio');
        } else if (this.controllerName == 'gerenciamentoCurso') {
            this.homologacao_atividade = new HomologacaoCurso();
            this.homologacao_atividade.nome_perfil_receptor = nome_perfil_receptor;
            this.homologacao_atividade.id_curso = obj['id'];
            this.homologacao_atividade.curso = { id: obj['id'], id_situacao };
        } else if (this.controllerName == 'gerenciamentoEvento') {
            this.homologacao_atividade = new HomologacaoEvento();
            this.homologacao_atividade.nome_perfil_receptor = nome_perfil_receptor;
            this.homologacao_atividade.id_evento = obj['id'];
            this.homologacao_atividade.evento = { id: obj['id'], id_situacao };
        } else if (this.controllerName == 'gerenciamento-banca') {
            this.homologacao_atividade = new HomologacaoBanca();
            this.homologacao_atividade.nome_perfil_receptor = nome_perfil_receptor;
            this.homologacao_atividade.id_banca = obj['id'];
            this.homologacao_atividade.banca = { id: obj['id'], id_situacao };
            propriedades.push('data_envio');
        } else if (this.controllerName == 'gerenciamentoCursoExterior') {
            this.homologacao_atividade = new HomologacaoCursoExterior();
            this.homologacao_atividade.nome_perfil_receptor = nome_perfil_receptor;
            this.homologacao_atividade.id_curso_exterior = obj['id'];
            this.homologacao_atividade.curso_exterior = { id: obj['id'], id_situacao };
        } else if (this.controllerName == 'gerenciamento-comissao') {
            this.homologacao_atividade = new HomologacaoComissao();
            this.homologacao_atividade.nome_perfil_receptor = nome_perfil_receptor;
            this.homologacao_atividade.id_comissao = obj['id'];
            this.homologacao_atividade.comissao = { id: obj['id'], id_situacao };
            propriedades.push('data_envio');
        } else if (this.controllerName == 'gerenciamentoProducaoIntelectual') {
            this.homologacao_atividade = new HomologacaoProducaoIntelectual();
            this.homologacao_atividade.nome_perfil_receptor = nome_perfil_receptor;
            this.homologacao_atividade.id_producao_intelectual = obj['id'];
            this.homologacao_atividade.producao_intelectual = { id: obj['id'], id_situacao };
            propriedades.push('data_envio');
        } else if (this.controllerName == 'gerenciamento-pos-graduacao') {
            this.homologacao_atividade = new HomologacaoPosGraduacao();
            this.homologacao_atividade.nome_perfil_receptor = nome_perfil_receptor;
            this.homologacao_atividade.id_pos_graduacao = obj['id'];
            this.homologacao_atividade.pos_graduacao = { id: obj['id'], id_situacao };
            propriedades.push('data_envio');
        }

        const questionamento = situacao === Situacoes['Aberto para Recurso'] ?
            'A atividade selecionada está aberta para recurso. Deseja realmente interpor recurso?' :
            'Deseja realmente enviar este registro?';
        this.observableUtilPanelDoc.setBlockedPanel(true);
        this.service.Adicionar(this.controllerName + "/verificarPrazo/", this.homologacao_atividade).subscribe(
            item => {

                this.observableUtilPanelDoc.setBlockedPanel(false);
                if (situacao !== Situacoes['Devolvido para Adequação']) {
                    if (item.prazoProfissionalAcabou && this.controllerName !== "gerenciamentoCurso" && this.controllerName !== "gerenciamentoEvento") {
                        if (!item.profissionalPrazoExtra) {
                            this.showMsgWarn(`O prazo para envio das atividades do exercício de ${item.exercicio} está finalizado.`);
                            return;
                        }
                    }
                    else if (item.prazoCapacitadoraAcabou && (this.controllerName === "gerenciamentoCurso" || this.controllerName === "gerenciamentoEvento")) {
                        this.showMsgWarn(`O prazo para envio das atividades do exercício de ${item.exercicio} está finalizado.`);
                        return;
                    }
                }
                this.confirmacao.confirm({
                    header: 'Confirmação',
                    message: questionamento,
                    accept: () => {
                        this.observableUtilPanelDoc.setBlockedPanel(true);

                        if (situacao === Situacoes['Aberto para Recurso']) {
                            this.router.navigate(['./abrir-recurso', obj['id']], { relativeTo: this.activatedRoute });
                        }
                        if (situacao !== Situacoes['Aberto para Recurso']) {
                            this.service.AtualizarAtividadeHomologacao(this.controllerName, this.homologacao_atividade, { parcial: propriedades }).subscribe(
                                () => {
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    this.listagem.refresh(this.filtro);
                                    this.showMsgSucess(`Registro foi enviado com sucesso.`);
                                },
                                err => {
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    if (err.status === 412) {
                                        this.showMsgWarn(`Atenção.<br> ${err._body}`)
                                        this.listagem.refresh(this.filtro);
                                        return;
                                    }

                                    this.showMsgError(`Houve um erro ao enviar o registro. ${err}`)
                                });
                        }
                    },
                    reject: () => {
                        if (situacao === Situacoes['Aberto para Recurso']) {
                            this.naoAbrirRecurso(obj['id'], this.controllerName, true, 500);
                        }
                    }
                });
            }, err => {
                super.showMsg('error', 'Mensagem de Erro', `Houve um erro ao verificar o prazo do registro.<br> ${err._body}`)
                this.observableUtilPanelDoc.setBlockedPanel(false);
            });
    }

    protected toggleLoading(loading: boolean): void {
        this.observableUtilPanelDoc.setBlockedPanel(loading);
      }
}



// WEBPACK FOOTER //
// ./src/app/base/base-list.component.ts